var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 12,
    viewBox: "0 0 111 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.535 6.53033C110.828 6.23744 110.828 5.76256 110.535 5.46967L105.762 0.696699C105.469 0.403806 104.994 0.403806 104.701 0.696699C104.408 0.989593 104.408 1.46447 104.701 1.75736L108.944 6L104.701 10.2426C104.408 10.5355 104.408 11.0104 104.701 11.3033C104.994 11.5962 105.469 11.5962 105.762 11.3033L110.535 6.53033ZM0 6.75H110.005V5.25H0V6.75Z",
    fill: "#0034EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTicket);
export default __webpack_public_path__ + "static/media/arrow_ticket.eeee9dca6bdb3090aa4008960eb20f47.svg";
export { ForwardRef as ReactComponent };